const steps = [
  {
    selector: '[data-tour="user-profile"]',
    content: "This is your profile"
  },
  {
    selector: '[data-tour="left-navigation"]',
    content: "This is main navigation",
  },
  {
    selector: '[data-tour="expand-navigation"]',
    content: "Use this button to collapse/expand navigation"
  },
  {
    selector: '[data-tour="dashboard-filter"]',
    content: "Using filters, you can set what projects you’d like the dashboard to visualize"
    },
  {
    selector: '[data-tour="tile-box"]',
    content: "These tiles show the number of projects at different steps of their lifecycle. You can click on a Tile to be redirected to the list of relevant projects."
  },
  {
    selector: '[data-tour="3-dots"]',
    content: "Adjust the Tiles by clicking on the 3 dots."
  },
  {
    selector: '[data-tour="task-aasign"]',
    content: "Tasks Assigned to Me displays your pending tasks. You can change the view by clicking between the Calendar and List icons"
  },
  {
    selector: '[data-tour="activity-feed"]',
    content: "The activity feed shows the most recent activity.",
  }

    
];

export default steps;




